export const CertificateProtect = {
  "Title": "Certificate Protection",
  "RecipientList": "Recipient list",
  "RecipientName": "Name",
  "RecipientIssuer": "Issuer",
  "RecipientExpires": "Expires",
  "RecipientCtrl": {
    "NewID": "New ID",
    "Import": "Import",
    "Browse": "Browse",
    "Remove": "Remove",
    "Permission": "Permission"
  },
  "PermissionSpecification": "Permission Specification",
  "Permissions": {
    "Printing": "Printing",
    "Accessibility": "Accessibility",
    "Copying": "Copying",
    "Changes": "Changes"
  },
  "EncryptSettings": "Encrypt Settings",
  "EncryptAlgorithm": "Encrypt Algorithm",
  "DontEncryptMetadata": "Don't encrypt metadata",
  "SaveToPolicy": "Save the settings as a new policy",
  "ErrorHasImported": "This certificate has already been imported.",
  "ErrorCantEncrypt": "This certificate is not available for encrypting.",
  "ErrorExceedValidity": "The certificate has exceeded the time of validity.",
  "ImportCertificate": {
    "Title": "Import Certificate",
    "SubTitle": "Please select one of your digital IDs to encrypt the document.",
    "IDs": "My Digital IDs",
    "StorageMechanism": "Storage Mechanism",
    "Refresh": "Refresh",
    "AddDigitalID": "Add Digital ID",
    "DigitalIDFile": "Digital ID File"
  }
}